tenderView.controller('tenderViewPreQualificationRequirementModalCtrl', function(
    $scope,
    $state,
    $timeout,
    $uibModalInstance,
    data,
    qualificationService,
    ntFlash
) {
    var tenderId = data.tenderId,
        qualificationId = data.qualificationId;

    $scope.disablePublishBtn = false;
    $scope.formData = {
        code: '24h',
        description: ''
    };

    $scope.publicRequirement = function() {
        $scope.disablePublishBtn = true;
        qualificationService.addMilestones(tenderId, qualificationId, $scope.formData)
            .then(data => {
                ntFlash.success(gettext('Вимогу про усунення невідповідностей створено'));
                console.log('qualificationService.addMilestones data', data);
                $uibModalInstance.close();
                $timeout(function() {
                    $state.reload();
                }, 1000);
            })
            .catch(error => {
                ntFlash.error(gettext('Сталася помилка', error));
                console.log('qualificationService.addMilestones error', error);
            })
            .finally(() => {
                $scope.disablePublishBtn = false;
            });
        $uibModalInstance.close(data);
    };

    $scope.close = function() {
        $uibModalInstance.close();
    };
});